document.addEventListener('DOMContentLoaded', () => {
  // Find the menu container
  const menuContainer = document.getElementById('collection-menu');
  if (!menuContainer) return;
  
  // Create loader for menu area only
  const loader = document.createElement('div');
  loader.id = 'menu-area-loader';
  loader.innerHTML = `
    <div class="menu-loader-content">
      <div class="menu-spinner"></div>
    </div>
  `;
  
  // Add CSS for menu loader
  const style = document.createElement('style');
  style.textContent = `
    #menu-area-loader {
      position: relative;
      width: 100%;
      min-height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      margin: 10px 0;
    }
    
    #menu-area-loader .menu-loader-content {
      text-align: center;
      padding: 20px;
    }
    
    #menu-area-loader .menu-spinner {
      width: 40px;
      height: 40px;
      border: 4px solid rgba(0, 0, 0, 0.1);
      border-left-color:#18449f;
      border-radius: 50%;
      animation: menu-spin 1s linear infinite;
      margin: 0 auto 15px;
    }
    
    #menu-area-loader .menu-loading-text {
      margin: 0;
      color: #555;
      font-size: 14px;
      font-weight: 500;
    }
    
    @keyframes menu-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    #menu-area-loader.hidden {
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
  `;
  
  document.head.appendChild(style);
  
  // Insert loader into menu container
  menuContainer.innerHTML = '';
  menuContainer.appendChild(loader);
  
  // Load sidebar after 2 sec
  setTimeout(() => {
    initSidebar();
    
    // Hide loader after sidebar is initialized
    const loaderEl = document.getElementById('menu-area-loader');
    if (loaderEl) {
      loaderEl.classList.add('hidden');
      
      // Remove loader from DOM after fade out
      setTimeout(() => {
        if (loaderEl.parentNode) {
          loaderEl.parentNode.removeChild(loaderEl);
        }
      }, 300);
    }
  }, 2000);
});

function initSidebar() {
  const dataEl = document.getElementById('collection-data');
  if (!dataEl) return;

  const data = JSON.parse(dataEl.textContent);

  /* ---------- BUILD TREE (FAST MAP VERSION) ---------- */
  const map = new Map();
  const tree = [];

  data.forEach(item => {
    map.set(item.id, { ...item, children: [] });
  });

  data.forEach(item => {
    const node = map.get(item.id);

    if (item.parent && map.has(item.parent)) {
      map.get(item.parent).children.push(node);
    } else {
      tree.push(node);
    }
  });

  function renderMenu(containerId) {
    const menuRoot = document.getElementById(containerId);
    if (!menuRoot) return;

    const fragment = document.createDocumentFragment();

    tree.forEach(item => {
      fragment.appendChild(createItem(item, true));
    });

    // Don't clear if loader is still there
    // menuRoot.innerHTML = '';
    menuRoot.appendChild(fragment);
  }

  function createLeaf(item) {
    const li = document.createElement('li');

    // ✅ Add main-category ONLY if level 1
    if (item.level === 1) {
      li.classList.add('main-category');
    }

    const a = document.createElement('a');
    a.href = item.url;
    a.textContent = item.title;

    li.appendChild(a);

    return li;
  }

  function createItem(item, isRoot = false) {
    // ✅ If no children → return simple leaf (old structure preserved)
    if (!item.children || item.children.length === 0) {
      return createLeaf(item);
    }

    const wrapper = document.createElement(isRoot ? 'div' : 'li');
    wrapper.className = isRoot
      ? 'category-box sidebaraccordion-item'
      : 'sidebaraccordion-item';

    const header = document.createElement('div');
    header.className = 'main-category sidebaraccordion-header';

    header.innerHTML = `
      <a class="header_span" href="${item.url}">${item.title}</a>
      <div class="term-icon">+</div>
    `;

    const content = document.createElement('div');
    content.className = `sub-categories-aside sidebaraccordion-content ${
      !isRoot ? 'nested-sidebaraccordion-content' : ''
    }`;

    const ul = document.createElement('ul');
    const childFrag = document.createDocumentFragment();

    item.children.forEach(child => {
      childFrag.appendChild(createItem(child));
    });

    ul.appendChild(childFrag);
    content.appendChild(ul);

    wrapper.appendChild(header);
    wrapper.appendChild(content);

    return wrapper;
  }

  renderMenu('collection-menu');
  initAccordion();
}

/* ---------- SUPER FAST ACCORDION ---------- */
function initAccordion() {
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.sidebaraccordion-header');
    if (!header) return;

    if (e.target.closest('a')) return;

    const item = header.parentElement;
    const content = item.querySelector(':scope > .sidebaraccordion-content');
    const icon = item.querySelector('.term-icon');

    if (!content) return;

    const isOpen = item.classList.toggle('open');
    content.style.display = isOpen ? 'block' : 'none';

    if (icon) icon.textContent = isOpen ? '-' : '+';
  });
}